function slideUp(element, duration = 600) {
    element.style.overflow = 'hidden';
    element.style.height = element.offsetHeight + 'px';
    element.offsetHeight; // force reflow
    element.style.transitionProperty = 'height, margin, padding';
    element.style.transitionDuration = duration + 'ms';
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;

    window.setTimeout(() => {
        element.style.display = 'none';
        element.style.removeProperty('height');
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition-duration');
        element.style.removeProperty('transition-property');
    }, duration);
}

function slideDown(element, duration = 600) {
    element.style.removeProperty('display');
    let display = window.getComputedStyle(element).display;
    if (display === 'none') display = 'block';
    element.style.display = display;

    const height = element.offsetHeight;
    element.style.overflow = 'hidden';
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;
    element.offsetHeight; // force reflow
    element.style.transitionProperty = 'height, margin, padding';
    element.style.transitionDuration = duration + 'ms';
    element.style.height = height + 'px';
    element.style.removeProperty('padding-top');
    element.style.removeProperty('padding-bottom');
    element.style.removeProperty('margin-top');
    element.style.removeProperty('margin-bottom');

    window.setTimeout(() => {
        element.style.removeProperty('height');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition-duration');
        element.style.removeProperty('transition-property');
    }, duration);
}

export default function() {
    document.querySelectorAll('.product_gallery_pager .slide').forEach((slide) => {
        slide.addEventListener('click', () => {
            if (!slide.classList.contains('active')) {
                document.querySelectorAll('.product_gallery_main .slide').forEach((el) => el.classList.remove('active'));
                document.querySelectorAll('.product_gallery_pager .slide').forEach((el) => el.classList.remove('active'));
                const index = slide.id.replace('slide-produit-', '');
                document.querySelectorAll('.product_gallery_pager .slide-' + index).forEach((el) => el.classList.add('active'));
                document.querySelectorAll('.product_gallery_main .slide-' + index).forEach((el) => el.classList.add('active'));
            }
        });
    });

    document.querySelectorAll('.menu > .menu-item-has-children').forEach((item) => {
        const chevron = document.createElement('span');
        chevron.classList.add('chevron');
        item.appendChild(chevron);
    });

    if (window.innerWidth < 1224) {
        document.querySelectorAll('.menu .menu-item-has-children a').forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();

                const parentItem = link.closest('.menu-item-has-children');
                const subMenu = link.nextElementSibling;

                if (parentItem.classList.contains('open')) {
                    parentItem.classList.remove('open');
                    if (subMenu) slideUp(subMenu);
                } else {
                    document.querySelectorAll('.menu-item-has-children').forEach((el) => el.classList.remove('open'));
                    document.querySelectorAll('.sub-menu').forEach((el) => el.style.display = 'none');
                    parentItem.classList.add('open');
                    if (subMenu) slideDown(subMenu);
                }
            });
        });
    }

    document.querySelectorAll('.ingredient').forEach((ingredient) => {
        ingredient.addEventListener('click', () => {
            ingredient.classList.toggle('active');
        });
    });

    document.querySelectorAll('.woof_container').forEach((group) => {
        const items = group.querySelectorAll('.woof_list > li');
        if (items.length > 5) {
            group.querySelector('.woof_list').classList.add('-column');
            group.classList.add('-column');
        }
    });
}
